export default __webpack_public_path__ + "static/media/appstoreWeb.b4e99992.svg";